module.exports = __webpack_public_path__ + "static/img/liantongCard_2.72301b50.png";